import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, inject, input, signal, viewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreakpointsService } from 'src/app/services/breakpoints.service';

@Component({
  selector: 'app-tags-group-list',
  standalone: true,
  imports: [
    TranslateModule
],
  templateUrl: './tags-group-list.component.html',
  styleUrls: ['./tags-group-list.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TagsGroupListComponent {
  public tagsGroupList = input.required<any[]>();

  private _translateService = inject(TranslateService);
  private _breakpointsService = inject(BreakpointsService);
  
  private _isMobile = computed(() => this._breakpointsService.isMobile());

  public currentLang = this._translateService.currentLang;
  public expandedGroups = new Set<number>(); // Track expanded groups by ID
  private _domIsReady = signal(false);

  // Method to check if a specific group's see-more button should be visible
  public isGroupSeeMoreButtonVisible(chipSetElement?: HTMLElement): boolean {
    if (!this._domIsReady() || !chipSetElement) return false;
    
    const chipSetEl = chipSetElement as HTMLElement;
    
    if (this._isMobile()) {
      return chipSetEl.scrollHeight > 312; // mobile: 8 lines of chips
    } else {
      return chipSetEl.scrollHeight > 72; // desktop: 2 lines of chips
    }
  }
  
  ngAfterViewInit(): void {
    this._domIsReady.set(true); 
  }
  
  public isTagNameWithBrackets(name: string): boolean {
    const regex = /\(.*?\)/;
    return regex.test(name);
  }
  
  public getTagNameWithoutBrackets(name: string): string {
    return name.replace(/\s*\(.*?\)\s*/g, '').trim();
  }
  
  public getBracketTagContent(name: string): string {
    const regex = /\((.*?)\)/;
    const match = name.match(regex);
    return match ? match[1] : '';
  }
  
  public isGroupExpanded(groupId: number): boolean {
    return this.expandedGroups.has(groupId);
  }

  public handleSeeMoreClick(groupId: number, chipSetElement: HTMLElement): void {
    const isExpanded = this.isGroupExpanded(groupId);

    chipSetElement.style.maxHeight = !isExpanded 
      ? 'fit-content' 
      : this._isMobile() ? '312px' : '72px'; // mobile: 8 lines of chips; desktop: 2 lines of chips

    if (isExpanded) {
      this.expandedGroups.delete(groupId);
    } else {
      this.expandedGroups.add(groupId);
    }
  }

}
